import React from 'react';

import MenuHeader from 'components/cosmos/menu';
import PropTypes from 'prop-types';

import './Sidebar.scss';

const Sidebar = ({ location }) => {
  return <MenuHeader locationMenu={location} />;
};

Sidebar.propTypes = {
  location: PropTypes.object.isRequired
};

export default Sidebar;
